/**
 * @ComponentFor Avensia.Shop.Features.Cms.Pages.ContentOverview.ContentOverviewPageViewModel
 */
import React from "react";
import Main from "Shared/PageLayout";
import ContentCardGrid from "Shared/ContentCardGrid";
import { EpiProperty, epiPropertyValue } from "@avensia/nitro5-scope-episerver";
import * as styles from "./base.scss";
class ContentOverviewPage extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement(Main, null,
            React.createElement(EpiProperty, { component: "h1", for: this.props.page.name }),
            !!epiPropertyValue(this.props.page.hero) && (React.createElement("div", { className: styles.hero },
                React.createElement("img", { src: epiPropertyValue(this.props.page.hero).url, alt: epiPropertyValue(this.props.page.name) }))),
            React.createElement("div", { className: styles.text },
                React.createElement(EpiProperty, { for: this.props.page.preamble })),
            React.createElement("div", { className: styles.text },
                React.createElement(EpiProperty, { for: this.props.page.mainBody })),
            React.createElement(ContentCardGrid, { currentBreakpoint: this.props.currentBreakpoint, cards: this.props.cards, showAll: true })));
    }
}
export default ContentOverviewPage;
